import React, {useRef} from "react";
import { clickTarif, sendTarifC2C, toggleLegalesTarif, sendTarifSE, preguntaanterior, closeModalTarif, validateTlf, validateTlf_SE } from "./utils";
import getColor from "@gcloud-npm/utils.enums.colors";
import Text from "@/bit/components/components.text"

const CotizadorMPA = () => {
const ref1_1 = useRef();
const ref1_2 = useRef();
const ref1_3 = useRef();
const ref2_1 = useRef();
const ref2_2 = useRef();
const ref3_1 = useRef();
const ref3_2 = useRef();
const ref3_3 = useRef();
const ref3_4 = useRef();
const ref4_1 = useRef();
const ref4_2 = useRef();
const ref4_3 = useRef();
const ref5_1 = useRef();
const ref5_2 = useRef();
const ref6_1 = useRef();
const ref6_2 = useRef();
const ref6_3 = useRef();
const ref7_1 = useRef();
const ref7_2 = useRef();

const colorBlue = getColor("BLUE");
const colorBlueA = getColor("BLUE_A");
const colorBlueDark = getColor("BLUE_DARK");
const colorRed = getColor("RED");
  return (
    <div>
    <div className="title-cotizador container">
        <Text 
            text="Contesta estas 7 sencillas preguntas para asesorarte mejor"
            size="title05"
            color={colorBlueDark}
            fontType="font-bold"
            cyData="CotizadorMPA Title"
        />
    </div>
      <div id="tarificador"></div>
      <div id="content" className="container" data-cy="CotizadorMPA container pasos">
        <div id="pasos" className="paso1" data-cy="CotizadorMPA container pasos">
          <span className="active"></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="pregunta" id="pregunta-1" data-cy="CotizadorMPA Pregunta 1">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 1: Vivienda</label>
          <p data-cy="CotizadorMPA Pregunta">¿Qué tipo de vivenda tienes?</p>
          <div className="respuestas" data-cy="CotizadorMPA Respuestas">
            <label ref={ref1_1} onClick={() => clickTarif(ref1_1.current,'1','vivienda')} data-cy="CotizadorMPA Opcion 1">
              <input id="ir1-1" type="radio" className="gtm-form" name="vivienda" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet-active.svg" />
              </div>
              <p>
                Adosado
                <br />o chalet
              </p>
            </label>
            <label ref={ref1_2} onClick={() => clickTarif(ref1_2.current,'1','vivienda')} data-cy="CotizadorMPA Opcion 2">
              <input id="ir1-2" type="radio" className="gtm-form" name="vivienda" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/pisos.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/pisos-active.svg" />
              </div>
              <p>
                Piso
                <br />
                en altura
              </p>
            </label>
            <label ref={ref1_3} onClick={() => clickTarif(ref1_3.current,'1','vivienda')} data-cy="CotizadorMPA Opcion 3">
              <input id="ir1-3" type="radio" className="gtm-form" name="vivienda" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/aticos-bajos.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/aticos-bajos-active.svg" />
              </div>
              <p>
                Ático
                <br />o bajo
              </p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-2" data-cy="CotizadorMPA Pregunta 2">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 2: Superficie</label>
          <p data-cy="CotizadorMPA Pregunta">¿Cuántos metros cuadrados tiene?</p>
          <div className="respuestas center" data-cy="CotizadorMPA Respuestas">
            <label ref={ref2_1} onClick={() => clickTarif(ref2_1.current,'2','superficie')} data-cy="CotizadorMPA Opcion 1">
              <input
                id="ir2-1"
                type="radio"
                className="gtm-form"
                name="superficie"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet-s.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet-s-active.svg" />
              </div>
              <p>
                Menos
                <br />
                de 90m2
              </p>
            </label>
            <label ref={ref2_2} onClick={() => clickTarif(ref2_2.current,'2','superficie')} data-cy="CotizadorMPA Opcion 2">
              <input
                id="ir2-2"
                type="radio"
                className="gtm-form"
                name="superficie"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet-active.svg" />
              </div>
              <p>
                Más
                <br />
                de 91m2
              </p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-3" data-cy="CotizadorMPA Pregunta 3">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 3: Servicio</label>
          <p data-cy="CotizadorMPA Pregunta">¿Tienes alarma?</p>
          <div className="respuestas col4" data-cy="CotizadorMPA Respuestas">
            <label ref={ref3_1} onClick={() => clickTarif(ref3_1.current,'3','servicio')} data-cy="CotizadorMPA Opcion 1">
              <input id="ir3-1" type="radio" className="gtm-form" name="servicio" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-abierto.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-abierto-active.svg" />
              </div>
              <p>No</p>
            </label>
            <label ref={ref3_2} onClick={() => clickTarif(ref3_2.current,'3','servicio')} data-cy="CotizadorMPA Opcion 2">
              <input id="ir3-2" type="radio" className="gtm-form" name="servicio" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/prosegur.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/prosegur-active.svg" />
              </div>
              <p>
                Sí,
                <br />
                Prosegur
              </p>
            </label>
            <label ref={ref3_3} onClick={() => clickTarif(ref3_3.current,'3','servicio')} data-cy="CotizadorMPA Opcion 3">
              <input id="ir3-3" type="radio" className="gtm-form" name="servicio" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/securitas.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/securitas-active.svg" />
              </div>
              <p>
                Sí,
                <br />
                Securitas
              </p>
            </label>
            <label ref={ref3_4} onClick={() => clickTarif(ref3_4.current,'3','servicio')} data-cy="CotizadorMPA Opcion 4">
              <input id="ir3-4" type="radio" className="gtm-form" name="servicio" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/seguridad.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/seguridad-active.svg" />
              </div>
              <p>
                Sí,
                <br />
                Otros
              </p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-4" data-cy="CotizadorMPA Pregunta 4">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 4: Ubicación</label>
          <p data-cy="CotizadorMPA Pregunta">¿Dónde está situada?</p>
          <div className="respuestas" data-cy="CotizadorMPA Respuestas">
            <label ref={ref4_1} onClick={() => clickTarif(ref4_1.current,'4','ubicacion')} data-cy="CotizadorMPA Opcion 1">
              <input
                id="ir4-1"
                type="radio"
                className="gtm-form"
                name="ubicacion"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/periferia.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/periferia-active.svg" />
              </div>
              <p>
                En la periferia
                <br />
                de un núcleo
                <br />
                urbano
              </p>
            </label>
            <label ref={ref4_2} onClick={() => clickTarif(ref4_2.current,'4','ubicacion')} data-cy="CotizadorMPA Opcion 2">
              <input
                id="ir4-2"
                type="radio"
                className="gtm-form"
                name="ubicacion"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/nucleo.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/nucleo-active.svg" />
              </div>
              <p>
                En un núcleo
                <br />
                urbano
              </p>
            </label>
            <label ref={ref4_3} onClick={() => clickTarif(ref4_3.current,'4','ubicacion')} data-cy="CotizadorMPA Opcion 3">
              <input
                id="ir4-3"
                type="radio"
                className="gtm-form"
                name="ubicacion"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/chalet-active.svg" />
              </div>
              <p>
                En una zona
                <br />
                aislada
              </p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-5" data-cy="CotizadorMPA Pregunta 5">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 5: Accesos</label>
          <p data-cy="CotizadorMPA Pregunta">¿Dispones de portero o vigilante?</p>
          <div className="respuestas center" data-cy="CotizadorMPA Respuestas">
            <label ref={ref5_1} onClick={() => clickTarif(ref5_1.current,'5','accesos')} data-cy="CotizadorMPA Opcion 1">
              <input id="ir5-1" type="radio" className="gtm-form" name="accesos" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/no-visto.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/no-visto-active.svg" />
              </div>
              <p>No</p>
            </label>
            <label ref={ref5_2} onClick={() => clickTarif(ref5_2.current,'5','accesos')} data-cy="CotizadorMPA Opcion 2">
              <input id="ir5-2" type="radio" className="gtm-form" name="accesos" />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/visto.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/visto-active.svg" />
              </div>
              <p>Sí</p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-6" data-cy="CotizadorMPA Pregunta 6">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 6: Ausencias</label>
          <p data-cy="CotizadorMPA Pregunta">¿Cuánto tiempo está tu vivienda vacía?</p>
          <div className="respuestas" data-cy="CotizadorMPA Respuestas">
            <label ref={ref6_1} onClick={() => clickTarif(ref6_1.current,'6','ausencias')} data-cy="CotizadorMPA Opcion 1">
              <input
                id="ir6-1"
                type="radio"
                className="gtm-form"
                name="ausencias"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/menos-de-3-horas.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/menos-de-3-horas-active.svg" />
              </div>
              <p>
                Menos de 3<br />
                horas al día
              </p>
            </label>
            <label ref={ref6_2} onClick={() => clickTarif(ref6_2.current,'6','ausencias')} data-cy="CotizadorMPA Opcion 2">
              <input
                id="ir6-2"
                type="radio"
                className="gtm-form"
                name="ausencias"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/mas-de-3-horas.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/mas-de-3-horas-active.svg" />
              </div>
              <p>
                Más de 3<br />
                horas al día
              </p>
            </label>
            <label ref={ref6_3} onClick={() => clickTarif(ref6_3.current,'6','ausencias')} data-cy="CotizadorMPA Opcion 3">
              <input
                id="ir6-3"
                type="radio"
                className="gtm-form"
                name="ausencias"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/siempre-protegido.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/siempre-protegido-active.svg" />
              </div>
              <p>
                Siempre
                <br />
                hay alguien
              </p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-7" data-cy="CotizadorMPA Pregunta 7">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 7: Seguridad</label>
          <p data-cy="CotizadorMPA Pregunta">¿Han robado alguna vez en tu vivienda?</p>
          <div className="respuestas center" data-cy="CotizadorMPA Respuestas">
            <label ref={ref7_1} onClick={() => clickTarif(ref7_1.current,'7','seguridad')} data-cy="CotizadorMPA Opcion 1">
              <input
                id="ir7-1"
                type="radio"
                className="gtm-form"
                name="seguridad"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-cerrado.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-cerrado-active.svg" />
              </div>
              <p>No</p>
            </label>
            <label ref={ref7_2} onClick={() => clickTarif(ref7_2.current,'7','seguridad')} data-cy="CotizadorMPA Opcion 2">
              <input
                id="ir7-2"
                type="radio"
                className="gtm-form"
                name="seguridad"
              />
              <div>
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-abierto.svg" />
                <img src="https://prod.cms.col.movistar.es/static/images/alarmas/tarificador/candado-abierto-active.svg" />
              </div>
              <p>Sí</p>
            </label>
          </div>
        </div>
        <div className="pregunta" id="pregunta-8" data-cy="CotizadorMPA Pregunta 8">
          <label data-cy="CotizadorMPA Title Pregunta">Paso 8: Contacto</label>
          <div id="Cotizador-C2C" data-cy="CotizadorMPA Final Step C2C">
            <p className="texto_presupuesto" data-cy="CotizadorMPA Final Text">
              Déjanos un teléfono de contacto para que agente especializado
              pueda contarte todos los detalles
            </p>
            <div className="form final">
              <div
                style={{width: "75%", textAlign: "center", margin: "auto"}}>
                <div
                  style={{flexDirection: "column",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"}}
                >
                  <input
                    id="telefonoTarif"
                    onBlur={() => validateTlf()}
                    className="inputTlfTarif gtm-form"
                    placeholder="Nº teléfono"
                    type="text"
                    maxLength="9"
                  />
                  <div className="errorTarif" id="errorTarifTlf" data-cy="CotizadorMPA Imput Error">
                    Este campo es obligatorio
                  </div>
                  <button
                    className="buttonTarif tealium_clic_PA-soteira-tarificador-quiero-presupuesto-clic"
                    id="buttonTarif"
                    onClick={() => sendTarifC2C()}
                    data-cy="CotizadorMPA Button Send C2C"
                  >
                    Quiero mi presupuesto gratuito
                  </button>
                </div>

                <a
                  className="legales_tarif"
                  title="He leído y acepto la información sobre privacidad"
                  onClick={() => toggleLegalesTarif()}
                  href="#"
                  data-cy="CotizadorMPA Link Privacidad"
                >
                  Consulta aquí la información sobre privacidad
                </a>
              </div>
            </div>
          </div>
          <div id="Cotizador-SE" data-cy="CotizadorMPA Final Step SE">
            <p data-cy="CotizadorMPA Final Text">
              Déjanos un teléfono de contacto para que agente especializado
              pueda contarte todos los detalles
            </p>
            <div className="form form_final">
              <div
                style={{width: "75%", textAlign: "center"}}>
                <div
                  style={{flexDirection: "column",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"}}
                >
                  <input
                    id="telefonoTarifSE"
                    onBlur={() => validateTlf_SE()}
                    className="inputTlfTarif gtm-form"
                    placeholder="Nº teléfono"
                    type="text"
                    maxLength="9"
                    data-cy="CotizadorMPA Imput Telf"
                  />
                  <div className="errorTarifSE" id="errorTarifTlfSE" data-cy="CotizadorMPA Imput Error">
                    Este campo es obligatorio
                  </div>
                  <button
                    className="buttonTarif tealium_clic_PA-soteira-tarificador-quiero-presupuesto-clic"
                    id="buttonTarif"
                    onClick={() => sendTarifSE()}
                    data-cy="CotizadorMPA Button Send SE"
                  >
                    Quiero mi presupuesto gratuito
                  </button>
                </div>

                <a
                  className="legales_tarif"
                  title="He leído y acepto la información sobre privacidad"
                  onClick={() => toggleLegalesTarif()}
                  href="#"
                  data-cy="CotizadorMPA Link Privacidad"
                >
                  Consulta aquí la información sobre privacidad
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="backarrow" onClick={() => preguntaanterior()} data-cy="CotizadorMPA Back Arrow">
          <img src="https://movistarnl.s3.amazonaws.com/tarificador/arrow.png" />
        </div>
      </div>

      <div id="overlay" data-cy="CotizadorMPA Pop Up">
        <div id="privacidad" data-cy="CotizadorMPA Pop Up Privacidad">
          <div id="closepopup" onClick={() => toggleLegalesTarif()} data-cy="CotizadorMPA Close Pop Up">
            +
          </div>
          <p className="" style={{fontSize: "16px !important", marginTop: "15px"}} data-cy="CotizadorMPA Pop Up Text">
            <b>Información sobre Privacidad</b>
            <br />
            <br />
            Movistar informa que los datos que se facilitan en el presente
            formulario serán tratados por Telefónica de España S.A.U. y
            Telefónica Móviles España S.A.U. (en adelante Movistar) como
            corresponsables con la finalidad de proporcionarle la información
            comercial solicitada, así como el resto de finalidades que se
            hubieran permitido o autorizado de conformidad con lo dispuesto en
            la
            <a target="_blank" href="/privacidad">
              Política de Privacidad.
            </a>
            <br />
            Movistar informa que dispondrá de los siguientes medios para ejercer
            sus derechos:
            <br />
            <br />· Si usted ya es Cliente, dirigiendo un escrito Referencia
            DATOS a la dirección de correo electrónico
            <a href="mailto:TE_datos@telefonica.com">TE_datos@telefonica.com</a>
            ; dirigiendo un escrito al Apartado de Correos 46155, 28080 Madrid;
            o a través del teléfono gratuito 224407 desde cada una de sus líneas
            fijas o móviles.
            <br />
            <br />· Si usted no es Cliente Movistar, podrá ponerse en contacto a
            través de la siguiente dirección de correo electrónico
            <a href="mailto:arcopcl@telefonica.com">arcopcl@telefonica.com</a>,
            o llamando al número 900 10 50 92.
          </p>
        </div>
      </div>

      <div id="modalTarif" className="modalTarif" data-cy="CotizadorMPA Modal">
        <div>
          <span className="closeModalTarif" onClick={() => closeModalTarif()} data-cy="CotizadorMPA Close Modal">
            +
          </span>
          <img
            className="hidden-xs"
            src="https://www.movistar.es/estaticos/LandingsGP/C2C/modal-tarificador-soteira-desktop.jpg"
            data-cy="CotizadorMPA Image Modal"
          />
          <img
            className="visible-xs"
            src="https://www.movistar.es/estaticos/LandingsGP/C2C/modal-tarificador-soteira-mobile.jpg"
            data-cy="CotizadorMPA Image Modal"
          />
        </div>
      </div>

      <style jsx>{`
        html {
            scroll-behavior: smooth;
        }
        .title-cotizador {
            margin-top: 2rem;
            margin-bottom: 2rem;
        }
        #content {
            background-color: #fbfbfb;
            margin: auto;
            text-align: center;
            padding: 30px 0;
            h1 {
                font-family: "Bold";
                padding: 20px;
                box-sizing: border-box;
                color: white;
                background-color: ${colorBlue};
            }
            input[type="radio"] {
                display: none;
            }
        }
        #pasos {
            width: 710px;
            margin: 50px auto;
            display: flex;
            justify-content: space-between;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 7px;
                background-color: #D8D8D8;
                height: 5px;
                width: 100%;
                display: block;
            }
            &::after {
                content: "";
                position: absolute;
                top: 7px;
                background-color: ${colorBlue};
                height: 5px;
                width: 0%;
                display: block;
                transition: 750ms;
            }
            span {
                width: 20px;
                height: 20px;
                display: block;
                border-radius: 50%;
                background-color: #D8D8D8;
                position: relative;
                z-index: 2;
                transition: 750ms;
                &::after {
                    position: absolute;
                    top: 0;
                    right: -3px;
                    display: block;
                    background-color: #fbfbfb;
                    width: 3px;
                    height: 100%;
                    content: "";
                    transition: 750ms;
                }
            }
            span.active {
                background-color: ${colorBlue};
            }
        }
        #pasos.paso2 {
            &::after {
                width: 14%;
            }
        }
        #pasos.paso3 {
            &::after {
                width: 28%;
            }
        }
        #pasos.paso4 {
            &::after {
                width: 42%;
            }
        }
        #pasos.paso5 {
            &::after {
                width: 56%;
            }
        }
        #pasos.paso6 {
            &::after {
                width: 70%;
            }
        }
        #pasos.paso7 {
            &::after {
                width: 84%;
            }
        }
        #pasos.paso8 {
            &::after {
                width: 100%;
            }
        }
        .pregunta {
            padding-bottom: 60px;
            text-align: left;
            width: 75%;
            margin: 0 auto;
            display: none;
            label {
                font-family: "Bold";
            }
            p {
                margin: 10px 0;
                font-family: "Light";
            }
            .respuestas {
                label {
                    p {
                        font-family: "Bold";
                    }
                }
            }
        }
        #pregunta-1 {
            display: block;
        }
        #pregunta-8 {
            padding: 10px 0px 60px;
            label {
                padding: 0px 55px;
            }
            p {
                padding: 0px 55px;
            }
        }
        .respuestas {
            margin-top: 40px;
            display: flex;
            gap: 60px;
            label {
                font-family: "Bold";
                margin: 0;
                padding: 0;
                width: 300px;
                background-color: #f1f1f1;
                border: 1px solid #979797;
                color: black;
                display: flex;
                align-items: center;
                border-radius: 5px;
                height: 100px;
                padding-left: 30px;
                gap: 0px;
                
                line-height: 27px;
                transition: 750ms;
                cursor: pointer;
                flex: none;
                box-sizing: border-box;
                &:hover {
                    background-color: ${colorBlue};
                    color: white;
                    border: 1px solid #019df4;
                    img {
                        &:first-child {
                            opacity: 0;
                        }
                        &:last-child {
                            opacity: 1;
                        }
                    }
                }
                img {
                    &:last-child {
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0;
                        transition: 750ms;
                    }
                }
                div {
                    width: 100px;
                    position: relative;
                }
            }
            label.active {
                background-color: ${colorBlue};
                color: white;
                border: 1px solid #019df4;
                img {
                    &:first-child {
                        opacity: 0;
                    }
                    &:last-child {
                        opacity: 1;
                    }
                }
            }
        }
        .respuestas.col4 {
            gap: 30px;
            label {
                width: 235px;
                div {
                    width: 80px;
                }
            }
        }
        .respuestas.center {
            justify-content: center;
            label {
                padding-left: 60px;
            }
        }
        #backarrow {
            display: none;
            width: 45px;
            height: 45px;
            border-radius: 5px;
            background-color: ${colorBlue};
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
                width: 14px;
            }
        }
        #backarrow.active {
            display: inline-flex;
        }
        #postalCodeTarif {
            width: 39%;
        }
        #llevate {
            background-color: rgba(254, 215, 0, 0.1);
            
            font-family: "Light";
            padding: 30px 55px;
            box-sizing: border-box;
            text-align: left;
            display: flex;
            align-items: center;
            margin-top: 50px;
            div {
                div {
                    height: 1px;
                    width: 150px;
                    margin: 15px 0;
                    background-color: black;
                }
            }
            b {
                font-family: "Bold";
            }
            img {
                max-width: 238px;
            }
        }
        #overlay {
            display: none;
            position: fixed;
            width: 100%;
            height: 100vh;
            overflow: auto;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.4);
            z-index: 10;
        }
        #overlay.active {
            display: block;
        }
        #buttonTarif {
            
            height: 50px;
        }
        #privacidad {
            display: block;
            position: fixed;
            max-width: 500px;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid #000;
            box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.4);
            background-color: white;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        #closepopup {
            font-family: "Light";
            position: absolute;
            top: 0px;
            right: 10px;
            
            transform: rotate(45deg);
            cursor: pointer;
        }
        #modalTarif {
            display: none;
            position: fixed;
            width: 100%;
            height: 100vh;
            overflow: auto;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.4);
            z-index: 10;
            div {
                position: absolute;
                top: 50%;
                left: 50%;
                border-radius: 20px;
                transform: translate(-50%, -50%);
                max-width: 898px;
                width: 90%;
            }
            img {
                max-width: 898px;
                width: 100%;
            }
            img.visible-xs {
                display: none;
            }
            .closeModalTarif {
                font-family: "Light";
                position: absolute;
                top: 0px;
                right: 10px;
                
                transform: rotate(45deg);
                cursor: pointer;
            }
        }
        #Cotizador-C2C {
            display: block;
            text-align: center;
        }
        #Cotizador-SE {
            display: none;
        }
        .form_final {
            margin: auto;
            margin-top: 2rem;
            display: flex;
            justify-content: center;
            align-content: center;
            width: 75%;
        }
        .div_percentage {
            width: 75%;
        }
        .inputTlfTarif {
            display: block;
            width: 50%;
            margin: auto;
            height: 50px;
            margin-top: 0.7rem;
            
        }
        .form {
            input {
                margin: 0.7rem 0;
                box-sizing: border-box;
                height: 50px;
                line-height: 50px;
                padding: 0 15px;
                border: 1px solid #979797;
                border-radius: 5px;
                
                font-family: "Regular";
            }
            div {
                &:first-child {
                    
                    flex-direction: column;
                }
                &:last-child {
                    display: flex;
                }
            }
            a {
                
                color: ${colorBlue};
                display: block;
                font-family: "Light";
                margin: 20px 0px;
            }
            b {
                color: ${colorBlue};
                font-family: "Bold";
                
            }
            button {
                display: block;
                padding: 0.5rem;
                width: 50%;
                background-color: ${colorBlueA};
                color: white;
                height: 40px;
                border: 0;
                border-radius: 5px;
                
                font-family: "Regular";
            }
        }
        .msgFormOK {
            color: ${colorBlue};
            
        }
        .msgFormKO {
            color: ${colorRed};
            
        }
        #errorTarifTlf {
            color: red;
            display: none;
            margin-left: 10px;
            
        }
        #errorTarifTlfSE {
            color: red;
            display: none;
            margin-left: 10px;
            
        }
        .separator-alarmas {
            width: 15px;
            height: 90px;
            border: 1px solid #979797;
            display: inline-block;
            border-left: 0;
            margin-left: 10px;
            margin-right: 30px;
            position: relative;
        }
        .separator {
            &:after {
                width: 15px;
                position: absolute;
                height: 1px;
                background-color: #979797;
                content: "";
                display: block;
                top: 50%;
                right: -15px;
            }
        }
        @media (max-width: 1150px) {
            .respuestas {
                gap: 30px;
                label {
                    flex: 1;
                    gap: 20px;
                    div {
                        width: auto;
                    }
                }
            }
            .pregunta {
                .respuestas {
                    label {
                        p {
                            
                            line-height: 24px;
                        }
                    }
                }
            }
            .respuestas.col4 {
                label {
                    div {
                        width: auto;
                    }
                }
            }
            .respuestas.center {
                label {
                    flex: none;
                }
            }
        }
        @media (max-width: 1000px) {
            #pasos {
                width: 620px;
            }
            .pregunta {
                p {
                    text-align: center;
                    display: block;
                }
            }
            .respuestas {
                flex-direction: column;
                label {
                    flex: none;
                    margin: 0 auto;
                }
            }
            #buttonTarif {
                width: 70%;
            }
        }
        @media (max-width: 760px) {
            #content {
                margin: 20px auto 60px;
                width: 90%;
            }
            #pasos {
                width: 90%;
            }
            .pregunta {
                padding: 10px 25px 60px;
                p {
                    
                }
            }
            .respuestas {
                label {
                    width: 100%;
                }
            }
            #pregunta-8 {
                label {
                    padding: 0px 25px;
                }
                p {
                    padding: 0px 25px;
                }
            }
            #llevate {
                flex-direction: column-reverse;
                text-align: center;
                gap: 30px;
                padding: 30px 25px;
                img {
                    width: 90%;
                }
            }
            .form {
                div {
                    &:first-child {
                        width: 100%;
                    }
                }
            }
            .separator {
                display: none;
            }
            #privacidad {
                position: absolute;
                top: 30px;
                left: 50%;
                transform: translate(-50%, -0%);
                width: 95%;
                box-sizing: border-box;
                margin-bottom: 30px;
            }
            #modalTarif {
                div {
                    max-width: 320px;
                }
                img.visible-xs {
                    display: block;
                }
                img.hidden-xs {
                    display: none;
                }
            }
            .texto_presupuesto {
                text-align: justify;
            }
            .inputTlfTarif {
                display: block;
                width: 100%;
                margin: auto;
                height: 50px;
                margin-top: 0.7rem;
                
            }
            #buttonTarif {
                text-align: center;
                margin: auto;
                width: 100%;
                height: 60px;
                margin-top: 0.7rem;
                
            }
            .legales_tarif {
                text-align: center;
            }
            .form_final {
                width: 100%;
            }
            #postalCodeTarif {
                width: 70%;
            }
            .div_percentage {
                width: 100% !important;
            }
        }
      `}</style>
    </div>
  );
};

export default CotizadorMPA;
